import { PriceWrapper } from "@/app/price"
import type { CollectionOfferGroup } from "@anaconda/core/nft-collection/collection/types"
import type { PriceValue } from "@anaconda/core/price/types"
import { cn } from "@rarible_int/anaconda_ui_components"
import { volumeBarPercentage } from "./volume-bar-percentage"

const SMALLEST_PRICE = 0.005

export function OfferPrice({
  offerGroup,
  bestTotalVolume,
}: {
  offerGroup: CollectionOfferGroup
  bestTotalVolume: string
}) {
  const { offerPrice: price, totalVolume } = offerGroup

  const percentage = volumeBarPercentage(totalVolume, bestTotalVolume)

  return (
    <div className="relative p-2">
      <div
        style={{ width: `${percentage}%` }}
        className={cn(
          "-z-10 absolute top-0 left-0 h-full rounded-sm bg-brand opacity-[0.06]",
        )}
      />
      <Price {...price} />
    </div>
  )
}

export function OfferTotalVolume({
  offerGroup,
}: { offerGroup: CollectionOfferGroup }) {
  return (
    <Price
      amount={offerGroup.totalVolume}
      currency={offerGroup.offerPrice.currency}
    />
  )
}

const minValuableNumber = {
  value: SMALLEST_PRICE,
  label: `<${SMALLEST_PRICE}`,
}

const priceFormat = {
  maximumFractionDigits: 2,
}

function Price(priceValue: PriceValue) {
  return (
    <PriceWrapper
      {...priceValue}
      format={priceFormat}
      minValuableNumber={minValuableNumber}
    />
  )
}
